import React, { Component } from 'react';

import Roller from './Roller/Roller'
import RollResults from './RollResults'
import DestinyContainer from './DestinyContainer/DestinyContainer'

// Likely we'll make different "apps" to pull in the correct
// dice for each system, and if it'll have destiny pool etc.
import {
  EoTAbility, EoTAdvantage, EoTBlack, EoTBoost,
  EoTChallenge, EoTDespair, EoTDifficulty, EoTFail,
  EoTForce, EoTProficiency, EoTSetback, EoTSuccess,
  EoTThreat, EoTTriumph, EoTWhite
} from './Dice/EoTDie';
import RandomDie from './Dice/RandomDie';

var diceTypes = [
  EoTAbility, EoTProficiency, EoTBoost, EoTDifficulty,
  EoTChallenge, EoTSetback, EoTForce, RandomDie,
];
var extraDiceTypes = [
  EoTAdvantage, EoTBlack, EoTDespair, EoTFail,
  EoTSuccess, EoTThreat, EoTTriumph, EoTWhite,
];


class EoTDiceApp extends Component {
  diceResults(results) {
    this.props.onUserRollAction(results)
  }

  render() {
    return (
      <div className="DiceApp">
        <div className="DiceAppSection">
          <DestinyContainer />
        </div>
        <div className="DiceAppSection">
          <Roller
            onUserRollAction={this.diceResults.bind(this)}
            diceTypes={diceTypes}
            extraDiceTypes={extraDiceTypes}
            rollType='ROLL.EOT'
          />
        </div>
        <div className="DiceAppSection">
          <RollResults resultList={this.props.results} />
        </div>
      </div>
    );
  }
}

export default EoTDiceApp;



// WEBPACK FOOTER //
// ./src/EoTDiceApp.js